import(/* webpackMode: "eager" */ "/app/src/app/[lang]/privacy-policy/loading.tsx");
